import { render, staticRenderFns } from "./BaseAdvertisementForm.vue?vue&type=template&id=21522130&"
import script from "./BaseAdvertisementForm.vue?vue&type=script&lang=js&"
export * from "./BaseAdvertisementForm.vue?vue&type=script&lang=js&"
import style0 from "./BaseAdvertisementForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports